export default {
  path: '/scores',
  name: 'scores',
  component: () => import('../components/score/Layout'),
  redirect: { name: 'ScoreList' },
  meta: {
    breadcrumb: 'profile.score.scores',
  },
  children: [
    {
      name: 'ScoreList',
      path: '',
      component: () => import('../views/score/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ScoreCreate',
      path: 'new',
      component: () => import('../views/score/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ScoreUpdate',
      path: ':id/edit',
      component: () => import('../views/score/Update'),
      meta: {
        breadcrumb: 'profile.score.score',
      },
    },
    {
      name: 'ScoreShow',
      path: ':id',
      component: () => import('../views/score/Show'),
      meta: {
        breadcrumb: 'profile.score.score',
      },
    }
  ]
};
